import wrapWithProvider from "./wrap-with-provider"
import "@fontsource/nunito-sans"

export const wrapRootElement = wrapWithProvider

export function onServiceWorkerUpdateReady() {
  window.alert("This site has been updated with new data. Please reload the site to get new data");
  window.location.reload(true);
}